export default "__VITE_ASSET__BPBxy2Qu__"